import React, { useState } from 'react'

import { styled as MuiStyled } from '@mui/material/styles'
import styled from 'styled-components'

import MuiDrawer from '@mui/material/Drawer'
import Fab from '@mui/material/Fab'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import AppBar from 'components/SideNavbar/AppBar'
import NavbarItems from 'components/SideNavbar/NavbarItems'
import Header from 'components/SideNavbar/Header'

import useScreenSize from 'hooks/useScreenSize'

import Brand from 'helpers/brand'

import { color } from 'styles/colors'
import { screenSize, sideNavbarCollapsedWidth, sideNavbarExpandedWidth } from 'styles/shared'

const SideNavbar = () => {
  const screenSize = useScreenSize()
  const isSmallScreen = screenSize === 'small'
  const [isSideNavbarOpen, setIsSideNavbarOpen] = useState(localStorage.getItem('isSideNavbarOpen') === 'true')

  const drawerWidth = !isSideNavbarOpen ? sideNavbarCollapsedWidth : sideNavbarExpandedWidth

  const onClickSidebarButton = () => {
    localStorage.setItem('isSideNavbarOpen', `${!isSideNavbarOpen}`)
    setIsSideNavbarOpen(!isSideNavbarOpen)
  }

  return (
    <>
      {isSmallScreen && !isSideNavbarOpen && <AppBar onClickMenuIconCallback={onClickSidebarButton} />}

      <S.Drawer
        variant={isSmallScreen ? 'temporary' : 'permanent'}
        open={isSideNavbarOpen}
        drawerWidth={drawerWidth}
        onClose={onClickSidebarButton}
        aria-label="side-navigation"
      >
        <S.SidebarButton onClick={onClickSidebarButton} drawerWidth={drawerWidth} aria-label="sidebar-button">
          {isSideNavbarOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </S.SidebarButton>

        <Header displayMiniVariantSidebar={!isSideNavbarOpen} />
        <NavbarItems displayMiniVariantSidebar={!isSideNavbarOpen} itemSelectedCallback={() => isSmallScreen && onClickSidebarButton()} />
        {isSideNavbarOpen && <S.BrandLogo src={Brand.brandLogoPath()} aria-label="brand-logo" alt={`${Brand.brandLogoPath()} logo`} />}
      </S.Drawer>
    </>
  )
}

export default SideNavbar

const S = {
  Drawer: MuiStyled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'drawerWidth' })(
    ({ drawerWidth }) => ({
      width: drawerWidth,
      flexShrink: 0,
      background: color('paneBackground'),
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      transition: '0.3s',

      '& .MuiDrawer-paper': {
        transition: '0.3s',
        width: drawerWidth, // !important, position is fixed for paper component.
        overflowY: 'auto',
        overflowX: 'hidden',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 6px 0px'
      }
    })
  ),

  BrandLogo: styled.img`
    display: block;
    height: 40px;
    margin-bottom: 20px;
    margin-top: auto;
  `,

  SidebarButton: MuiStyled(Fab, { shouldForwardProp: (prop) => prop !== 'drawerWidth' })(
    ({ drawerWidth }) => ({
      position: 'fixed',
      top: '70px',
      left: drawerWidth - 10,
      height: '20px',
      width: '20px',
      minHeight: '20px',
      zIndex: 1250,
      backgroundColor: color('navbarArrowBackground'),
      color: color('primaryButtonText'),
      transition: '0.3s',

      '&:hover': {
        backgroundColor: color('navbarArrowBackgroundHover'),
        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 10px'
      },

      [`@media ${screenSize.small}`]: {
        visibility: 'hidden'
      }
    }))
}
